import axios from "axios";
import { defineStore } from "pinia"
import { getToken } from '@josempgon/vue-keycloak'



// Assume 'this.$keycloak' is available in your component
// const accessToken = this.$keycloak.token;

export const useTargetStore = defineStore('target', {
    state: () => ({
        targets: null,
    }),
    actions: {
        async getUserTargets() {
            const token = await getToken()
            await axios.get('/user_targets', { // URL of your Python backend
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              }).then(async (response) => {
                    if (response.status == 200) {
                        this.$state.targets = response.data
                    }
                }
            ).catch(async (error) => {
                //console.log(error.toJSON())
                console.log(error)
            })
        },
        async createTarget(target){
            const token = await getToken()
            await axios.post('/create_target', target, { // URL of your Python backend
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              })
            await this.getUserTargets()
        },
        async updateTarget(target, target_id){
            const token = await getToken()
            await axios.patch(`/target/${target_id}`, target, { // URL of your Python backend
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              })
            await this.getUserTargets()
        },
        async deleteTarget(target_id){
            const token = await getToken()
            await axios.delete(`/target/${target_id}`, { // URL of your Python backend
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              })
            await this.getUserTargets()
        },
        async getMinDistance(lat, lon) {
            const token = await getToken()
            await axios.get(`/min_distance/${lat}/${lon}`, { // URL of your Python backend
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              }).then(async (response) => {
                    if (response.status == 200) {
                        this.$state.minDistance = response.data
                    }
                }
            ).catch(async (error) => {
                //console.log(error.toJSON())
                console.log(error)
            })
        }
    },
    getters: {
        stateTargets: state => state.targets,
        targetsGeoJSON: state => {
            let geojson = {
                type: "FeatureCollection",
                features: new Array()
            }
            if(state.targets) {
                state.targets.forEach((target) => {
                    geojson.features.push({
                        type: "Feature",
                        properties: {
                            "@id": target.id,
                            name: target.name,
                            user: target.user,
                            address: target.address 
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                target.y,
                                target.x
                            ]
                        },
                        "id": target.id
                    })
                })
            }
            return geojson
        }
    }
})